import React from 'react';
import FundInvestment from '../FundInvestment';

function TestForm() {
    return (
        <>
            <FundInvestment />
        </>
    );
}

export default TestForm;